import "./Home.css";
import Post from "./Post";

export default function Home() {
  return (
    <div className="homemain">
      <Post />
    </div>
  );
}
